export default {
  heading: {
    widgetName: "captain",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Exclusive Partnership Deals for All airasia ride Drivers",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `riderbenefits | captain`,
      eventLabelCardClick: `riderbenefits | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `riderbenefits | headline | {{headline}}`,
      eventLabelView: `riderbenefits`,
    },
  },


  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/ride/benefits/images/captain-flight.jpg",
      title: "Perks for our Captains",
      subtitle: "Enjoy this exclusive airasia driver reward as a token of our appreciation.",
      cta: "Redeem Now",
      url: "https://www.airasia.com/aa/about-us/en/gb/ride-terms-and-conditions.html#90OFFAirAsiaFlights",
    },
   {
           primaryLabel: "",
           image: "https://www.airasia.com/aa/ride/benefits/images/mahkota-medical-center-widget-captain.jpeg",
           title: "Exclusively for Captains",
           subtitle: "Get a FREE blood test at Mahkota Medical Centre!",
           cta: "Redeem Now",
           url: "https://www.airasia.com/aa/about-us/en/gb/ride-terms-and-conditions.html#mahkotamedicalcentre",
         }
  ],
}
